












import { Component, Prop, Vue } from 'vue-property-decorator';
import { ExprBinaryOp, BinaryOps } from '../../cablin/exprs';
import SimpleExprComp from './SimpleExpr.vue';

@Component({
  components: {
    SimpleExprComp,
  },
})
export default class ExprUnaryOpComp extends Vue {
  @Prop() private expr!: ExprBinaryOp
  BinaryOps = BinaryOps
}
